import { observable } from 'mobx';
import { AppConstants, Types } from '../../../common/APIConstants';
import ReferenceDataAPI from '../../referencedata/services/reference-data-service';
import _ from 'lodash';
class MarketingRepUserStore {
  @observable initialValues = '';
  @observable editBtnText = 'Edit User';
  @observable addRowBtnText = 'Add New User';
  @observable exportBtnText = 'Export';
  @observable refreshBtnText = 'Refresh';
  @observable screenRowData = [];
  @observable rowData = [];
  @observable columnDefinitions = [];
  @observable rowDataFetched = false;
  @observable fields = [
    "AlternateUser",
    "AlternateUserEmailID",
    "CreatedBy",
    "CreatedOn",
    "EscalationUser1",
    "EscalationUser1EmailID",
    "EscalationUser2A",
    "EscalationUser2AEmailID",
    "EscalationUser2B",
    "EscalationUser2BEmailID",
    "ID",
    "IsActive",
    "MarketingRepEmailID",
    "MarketingRepID",
    "MarketingRepName",
    "UpdatedBy",
    "UpdatedOn"
  ];

  getScreenData = async (currentScreen, CommonStore) => {
    CommonStore.toggleLoader();
    this.hasScreenData = false;
    try {
      const { data } = await ReferenceDataAPI.getGridData(currentScreen);
      const { screen, screenColumns: columns } = currentScreen;
      this.columnDefinitions = [];
      this.rowData = [];
      this.selectedData = [];

      this.columnDefinitions = this.getColumnDefinitions(screen, columns);
      this.rowData = data;
      this.screenRowData = data;
      this.rowDataFetched = true;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      }
      else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  saveScreenData = async (saveObj, CommonStore, currentScreen, saveMode, EmailOnUpdate, isAcknowledgeUpdate) => {
    CommonStore.toggleLoader();
    try {
      const addScreen = {};
      Object.assign(addScreen, currentScreen);
      addScreen.data = saveObj;
      if (saveMode === "Save") {
        await ReferenceDataAPI.saveData(addScreen);
      } else if (saveMode === "Update") {
        await ReferenceDataAPI.updateData(addScreen);
      }
      window.toastr.success(AppConstants.TOASTER_SUCCESS);
      CommonStore.toggleLoader();
    }
    catch (error) {
      CommonStore.toggleLoader();
      window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
    }
  };


  getColumnDefinitions = (screen, columns) => {
    const gridColumns = [];
    columns.forEach((column) => {
      gridColumns.push({
        field: column.name,
        headerName: column.title,
        type: 'text',
        hide: column.hidden,
        width: column.width ? column.width : 200,
        keyCreator: (params) => { return this.getValueFomatter(params, column, screen) ? this.getValueFomatter(params, column, screen) : params.value },
        editable: (params) => { return this.getIsEditable(params, column, screen) },
        cellClassRules: {
          'highlight-cell': (params) => { return this.getIsEditable(params, column, screen) },
          'grid-cell-custom': (params) => { return params.data ? true : false }
        },
        filter: this.getColumnFilter(column),
        cellRenderer: this.getCellRenderer(column),
        cellEditor: this.getCellEditor(column),
        cellEditorParams: (params) => this.getCellEditorParams(column, params),
        valueFormatter: (params) => { return this.getValueFomatter(params, column, screen) }
      });
    });
    return gridColumns;
  };

  getIsEditable(params, column, screen) {

    return true;
  }

  getCellRenderer(column) {
    switch (column.type) {
      case Types.BOOLEAN:
        return 'booleanTextFormatter';
      case Types.DATETIME:
        return 'dateFormatter';
    }
  }

  getCellEditor(column) {
    switch (column.type) {
      case Types.DROPDOWN:
        return 'SmartSelect';
    }
  }
  getCellEditorParams(column, params) {

    switch (column.type) {
      case Types.DROPDOWN:
        return { values: column.refLookupData?.lookupValues.values, isPopup: true };
    }
  }
  getColumnFilter(column) {
    switch (column.type) {
      case Types.DATE:
        return 'agDateColumnFilter';
      case Types.DATETIME:
        return 'agDateColumnFilter';
      case Types.NUMBER:
        return 'agNumberColumnFilter';
      case Types.DECIMAL:
        return 'agNumberColumnFilter';
      case Types.TEXT:
        return 'agTextColumnFilter';
      default:
        return 'agSetColumnFilter';
    }
  }


  getValueFomatter(params, column, screen) {
    if (params.value) {
      if (column.type === Types.DROPDOWN && column.refLookupData != null) {
        return this.lookupValue(column.refLookupData.lookupValues, params.value);
      }
      else {
        switch (column.type) {
          case Types.DATETIME:
            return 'dateTimeFormatter';
          case Types.BOOLEAN:
            return 'booleanTextFormatter';

        }

      }
    }
  }

  lookupValue(mappings, key) {
    if (!mappings || mappings === 'undefined' || !mappings.values.find(item => item.value === key)) return null;
    else {
      let label = mappings.values.find(item => item.value === key).label;
      return label;
    }
  }
  getInitialValues() {
    this.initialValues = {
      ID: '',
      MarketingRepID: '',
      MarketingRepName: '',
      MarketingRepEmailID: '',
      AlternateUser: '',
      AlternateUserEmailID: '',
      EscalationUser1: '',
      EscalationUser1EmailID: '',
      EscalationUser2A: '',
      EscalationUser2AEmailID: '',
      EscalationUser2B: '',
      EscalationUser2BEmailID: '',
      IsActive: '',
    }
  }
}

export default new MarketingRepUserStore();